import styled from "styled-components";

export const Form = styled.form``;

export const Hint = styled.small`
	font-size: var(--font-size-small);
	font-weight: 600;
	line-height: 150%;
`;

export const ListRequirements = styled.ul`
	list-style: none;
	padding: unset;
	margin: unset;
`;

export const ItensRequirements = styled.li`
	display: flex;
	gap: 0.313rem;
`;
